<div class="modal__content">
    <div class="modal__list">
        <div class="checkout__item" *ngFor="let option of gradingOptions" [class.item--selected]="isSelected(option)" (click)="select(option)">
            <h5>{{option.name}}</h5>
        </div>
    </div>
</div>
<modal-actions [options]="options" [type]="type"></modal-actions>